import React, { useContext, useEffect, useState } from "react";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import FloatingSelect from "../../atoms/floatingSelect/floatingSelect";
import Button from "../../atoms/dropdown/dropdown";
import GenericModal from "../../GenericModal/index";
import { useHistory } from "react-router";
import { makeAPICall } from "src/services/apiService";
import axios from "axios";
import BackArrow from "src/atoms/backArrow/backArrow";
import { Link } from "react-router-dom"; 
import exchangeIcon from "../../assets/images/swap.svg"
import PlusIcon from "../../assets/images/plusIcon.svg"
import "./exchange.scss"
import { getPaymentAmout } from "../../utils/utils";
import DeleteIcon from "../../assets/images/deleteOrderIcon.svg"
import CheckTick from "../../assets/images/checked-tick.svg"
import checked from "../../assets/fieldIcons/checked.svg"
import Loader from "../../atoms/Loader"

function ScooterExchangeVerify() {
  const history = useHistory();
  const loan = ["Completed", "Pending"];
  const condtion = ["Running", "Not working"];
  const ownerships = [1, 2, 3, 4, 5];
  const [range, setRange] = useState([
    {
      "id": 1,
      "from_distance": 0,
      "to_distance": 10000,
    },
    {
      "id": 2,
      "from_distance": 10001,
      "to_distance": 20000,
    },
    {
      "id": 3,
      "from_distance": 20001,
      "to_distance": 30000,
    },
    {
      "id": 4,
      "from_distance": 30001,
      "to_distance": 40000,
    },
    {
      "id": 18,
      "from_distance": 40001,
      "to_distance": 60000,
    },
    {
      "id": 19,
      "from_distance": 60000,
      "to_distance": 300000,
    }
  ]);
  const [continueBtnDisabled, setContinueBtnDisabled] = useState(true);
  const [responseArray, setResponseArray] = useState([]);
  const [previousBikeData, setPreviousBikeData] = useState({});
  const [bikePayload, setBikePayload] = useState({});
  // exchange partner states
  const [exchangePatner, setExchangePatner] = useState({})
  const [showExchangePatner, setShowExchangePatner] = useState(false)
  const [exchangeSelected, setExchangeSelected] = useState(false)
  const [exchangePatnerData, setExchangePatnerData] = useState([])
  const [filterPartnerArray, setFilterPartnerArray] = useState([])
  const [searchPartner, setSearchPartner] = useState("")


  //brand states
  const [brandName, setBrandName] = useState("");
  const [showBrand, setShowBrand] = useState(false);
  const [brandSeleceted, setBrandSelected] = useState(false);

  //model states
  const [modelName, setModelName] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [modelSeleceted, setModelSelected] = useState(false);

  //model Year states
  const [modelYear, setModelYear] = useState("");
  const [showModelYear, setShowModelYear] = useState(false);
  const [modelYearSeleceted, setModelYearSelected] = useState(false);

  //loan states
  const [bikeLoan, setBikeLoan] = useState("");
  const [showBikeLoan, setShowBikeLoan] = useState(false);
  const [bikeLoanSeleceted, setBikeLoanSelected] = useState(false);

  //bike condition states
  const [bikeCondtion, setBikeCondtion] = useState("");
  const [showBikeCondition, setShowBikeCondition] = useState(false);
  const [bikeConditionSeleceted, setBikeConditionSelected] = useState(false);

  //owner name state
  const [ownersName, setOwnersName] = useState("");

  //Biker reg num state
  const [regNumber, setRegNumber] = useState("");

  // Transaction Id state
  // const [transactionId, setTransactionId] = useState("")

  //Ownership states
  const [ownership, setOwnership] = useState("");
  const [showOwnership, setShowOwnership] = useState(false);
  const [ownershipSeleceted, setOwnershipSelected] = useState(false);

  //kilometer states
  const [kilometer, setKilometer] = useState({
    from_distance: null,
    to_distance: null,
  });
  const [showBikeRange, setShowBikeRange] = useState(false);
  const [bikeRangeSelected, setBikeRangeSelected] = useState(false);

  const [toastMsg, setToastMsg] = useState("")
  const [showToggle, setShowToggle] = useState(false)

  const [dataOfSelectedBrand, setDataOfSelectedBrand] = useState({});
  const [brands, setBrands] = useState([])
  const [models, setModels] = useState([])
  const [variants, setVariants] = useState([])
  const [colors, setColors] = useState([])
  const [modelRef, setModelRef] = useState("")
  const [year, setyear] = useState([]);
  const [callTime, setCallTime] = useState(false);
  const ownershipMap = { 1: "First", 2: "Second", 3: "Third", 4: "Fourth", 5: "Fifth" };
  const [showVerifyPopup, setShowVerifyPopup] = useState(false)
  const vehConditionLimit = 10
  const [vehConditionList, setVehConditionList] = useState({})
  const scooterRegImgLimit = 1
  const [scooterRegList, setScooterRegList] = useState({})
  const [exchangeValue, setExchangeValue] = useState("")
  const [orderUserData, setOrderUserData] = useState({})
  const [registrationNo, setRegistrationNo] = useState("")
  const [showToast, setShowToast] = useState('none');
  const [toastMessage, setToastMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false)

  const [vendorKey, setVendorKey] = useState("")
  const [vendorKeyCF, setVendorKeyCF] = useState("");

  //variant states
  const [variantName, setVariantName] = useState("")
  const [showVariant, setShowVariant] = useState(false)
  const [variantSeleceted, setVariantSelected] = useState(false)

  //color states
  const [colorName, setColorName] = useState("")
  const [showColor, setShowColor] = useState(false)
  const [colorSeleceted, setColorSelected] = useState(false)
  const [pincode, setPincode] = useState("")

  const [verifyPopup, setVerifyPopup] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [otherRemarks, setOtherRemarks] = useState("")

  const [searchedBrand, setSearchedBrand] = useState("")
  const [searchedModel, setSearchedModel] = useState("")
  const [searchedVariant, setSearchedVariant] = useState("")

  const [colorGroups, setColorGroups] = useState({})
  const [colorGroupSelected, setColorGroupSelected] = useState("")
  const rejectReasons = [
    "Customer not happy with exchange  amount offered",
    "Vehicle condition doesn’t match the provided description",
    "Vehicle ownership documents are not valid or not in the name of the seller",
    "The vehicle has significant mechanical or structural damage",
    "The vehicle has a significant history of accidents or repairs",
    "The vehicle has been reported stolen or has an outstanding loan on it",
    "The vehicle’s odometer reading is significantly higher than the provided description",
    "The vehicle has missing or damaged components that affect its functionality or safety",
    "The vehicle is not eligible for exchange due to age or model",
    "Others",
  ];

  const [showSplitErrorPopup, setShowSplitErrorPopup] = useState(false);
  const [splitPayErrorHeader, setSplitPayErrorHeader] = useState("");
  const [splitPayErrorSubtext, setSplitPayErrorSubtext] = useState("");

  useEffect(() => {
    getExchangeStaticData()
    setOrderUserData(history.location.state)
    // getAllBrands();
      // let config = {
      //   method: "get",
      //   url: `api/exchange/getModelData`,
      //   headers: {
      //     'x-flow': "CUSTOMER_CREATE_BC_EDIT"
      //   }
      // };
      // makeAPICall(config)
      //   .then((resp) => {
      //     if (resp?.data) {
      //       setResponseArray(resp.data.data.exchange_specifications);
      //       setRange(resp.data.data.distance_ranges);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     toggleToaster(`Somethin went wrong`)
      //   });



          let config = {
            method: "get",
            url: `api/exchange/getExchangeOrderDetail`,
            params: {
              ...history.location.state,
            },
          };
    
          makeAPICall(config)
            .then((resp) => {
              if (resp && resp.data.status === "SUCCESSFUL") {
                setPreviousBikeData(resp.data.data);
              }
            })
            .catch((err) => {
              console.log("failed");
              toggleToaster(`Somethin went wrong`)
            });
    
    let payload = {
      method: "get",
      url: 'api/exchange/exchangePatnerData'
    }
    makeAPICall(payload)
      .then((response) => {
        console.log("this is echange patner response", response?.data);
        setExchangePatnerData(response?.data?.data)
      })
      .catch((err) => {
        console.log("error in getting patner data", err);
        toggleToaster(`Somethin went wrong`)
      })


  }, []);

  useEffect(() => {
      if (previousBikeData) {
          getDataAccToPrevBikeData()
      } else {
          getAllBrands()
      }
  }, [previousBikeData])

  useEffect(() => {
    if(previousBikeData && colorGroups && colors.length && colorName) {
        let preColorRef = colors.find(item => item.color == previousBikeData?.color)
        if(preColorRef) {
            getAllYears(preColorRef)
        }
    }
  }, [colorGroups, colors])

    const getDataAccToPrevBikeData = async () => {
      if (
        previousBikeData?.brand &&
        previousBikeData?.model &&
        previousBikeData?.variant &&
        previousBikeData?.color
      ) {
        getAllBrands().then((res) => {
            console.log(res, "getAllBrands, resss")
          getAllModels(previousBikeData?.brand).then((ress) => {
            console.log(ress, "getAllModels, resss")
            getAllVariants(previousBikeData?.model, {brand: previousBikeData?.brand}).then((resss) => {
                console.log(resss, "getAllVariants, resss")
              getAllColors(previousBikeData?.variant, {brand: previousBikeData?.brand, model: previousBikeData?.model});
            });
          });
        });
      }
    };

  useEffect(() => {
    setFilterPartnerArray([...exchangePatnerData])
  }, [exchangePatnerData])

  useEffect(() => {
    if (previousBikeData) {
      setBrandName(previousBikeData?.brand);
      setBrandSelected(previousBikeData?.brand ? true : false);
      setModelName(previousBikeData?.model);
      setModelSelected(previousBikeData?.model ? true : false);
      setModelYear(previousBikeData?.year);
      setModelYearSelected(previousBikeData?.year ? true : false);
      setBikeLoan(previousBikeData?.other_attributes?.loan_status);
      setBikeLoanSelected(
        previousBikeData?.other_attributes?.loan_status ? true : false
      );
      setBikeCondtion(previousBikeData?.other_attributes?.running_condition);
      setBikeConditionSelected(
        previousBikeData?.other_attributes?.running_condition ? true : false
      );
      setOwnersName(previousBikeData?.owner_name);
      setKilometer({
        from_distance: previousBikeData?.from_distance,
        to_distance: previousBikeData?.to_distance,
      });
      setBikeRangeSelected(
        previousBikeData?.from_distance || previousBikeData?.to_distance
          ? true
          : false
      );
      setRegNumber(previousBikeData?.other_attributes?.registration_number);
      setOwnership(previousBikeData?.other_attributes?.ownership);
      setOwnershipSelected(
        previousBikeData?.other_attributes?.ownership ? true : false
      );

      let currencyValue = previousBikeData?.exchange_value + ''
      currencyValue = currencyValue?.replace(/[^0-9 ]/g, "");
      currencyValue = currencyValue?.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
      currencyValue = "₹" + currencyValue;
      setExchangeValue(currencyValue)
      setRegistrationNo(previousBikeData?.other_attributes?.registration_number)
      // setTransactionId(previousBikeData?.transaction_id || "")

      setVariantName(previousBikeData?.variant)
      setVariantSelected(previousBikeData?.variant ? true : false)
      if(previousBikeData?.color in colorGroups) {
        setColorName(colorGroups[previousBikeData?.color]?.join("/"))
      } else {
        setColorName(previousBikeData?.color)
      }
      setColorSelected(previousBikeData?.color ? true : false)
      setPincode(previousBikeData?.pin_code)
      setVendorKey(previousBikeData?.other_attributes?.vendor_key)
      setVendorKeyCF(previousBikeData?.other_attributes?.vendor_key_customer_flow)
    }
    if (responseArray && previousBikeData) {
      setDataOfSelectedBrand(
        responseArray.find((a) => a.brand == previousBikeData?.brand)
      );
      setyear(responseArray.find((a) => a.brand == previousBikeData?.brand)?.models.find(model => model.model == previousBikeData?.model)?.variants.find(v => v.variant == previousBikeData?.variant)?.colors.find(col => col.color == previousBikeData?.color)?.year)
    }
    checkLogicForBtnDisabled();
  }, [previousBikeData, colorGroups]);

  useEffect(() => {
    checkLogicForBtnDisabled();
    if (!continueBtnDisabled) {
      let exchange_value = exchangeValue + ''
      exchange_value = Number(exchange_value?.replace(/[^0-9 ]/g, ""));
      let payload = {
        order_id: orderUserData?.order_id || "",
        brand: brandName,
        model: modelName,
        year: Number(modelYear),
        owner_name: ownersName,
        from_distance: kilometer.from_distance,
        to_distance: kilometer.to_distance,
        other_attributes: {
          partner_id: exchangePatner?.id,
          running_condition: bikeCondtion,
          loan_status: bikeLoan,
          registration_number: regNumber,
          ownership: ownership,
          registration_number: registrationNo
        },
        is_home_pickup: previousBikeData?.is_home_pickup || true,
        exchange_value,
        pin_code: Number(pincode),
        variant: variantName,
        color: colorGroupSelected || colorName,
        // transaction_id: transactionId
      };
      setBikePayload(payload);
    }
  }, [
    exchangePatner,
    brandName,
    modelName,
    modelYear,
    bikeLoan,
    bikeCondtion,
    ownersName,
    ownership,
    regNumber,
    kilometer.from_distance,
    kilometer.to_distance,
    continueBtnDisabled,
    exchangeValue,
    vehConditionList,
    scooterRegList,
    registrationNo,
    variantName,
    colorName,
    pincode,
    // transactionId
  ]);

  //   useEffect(() => {
  //     checkLogicForBtnDisabled();
  //   }, [exchangeDiscountQotation]);

  async function getAllBrands() {
    let config1 = {
      method: "get",
      url: `api/exchange/get-all-brands`,
      headers: {
        'x-flow': "BC_CREATE",
        "x-tenant": ""
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setBrands(resp.data.data.exchange_info_list);
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllModels(el) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-brand-models`,
      headers: {
        'x-flow': "BC_CREATE",
        "x-tenant": ""
      },
      params: {
        brandName: el,
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setModels(resp.data.data.exchange_info_list);
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllVariants(el, bod) {
    console.log(el, brandName, previousBikeData.brand)
    let config1 = {
      method: "get",
      url: `api/exchange/get-model-variants`,
      headers: {
        'x-flow': "BC_CREATE",
        "x-tenant": ""
      },
      params: {
        brandName: brandName || bod.brand,
        modelName: el
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setVariants(resp.data.data.exchange_info_list);
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllColors(el, bod) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-variant-colors`,
      headers: {
        'x-flow': "BC_CREATE",
        "x-tenant": ""
      },
      params: {
        brandName: brandName || bod.brand,
        modelName: modelName || bod.model,
        variant: el,
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setColors(resp?.data?.data?.exchange_info_list);
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllYears(el) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-color-years`,
      headers: {
        'x-flow': "BC_CREATE",
        "x-tenant": ""
      },
      params: {
        brandName: brandName || previousBikeData.brand,
        modelName: modelName || previousBikeData.model,
        variant: variantName || previousBikeData.variant,
        color: el?.color || previousBikeData.color,
        model_ref: el?.model_ref || modelRef
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setyear(resp.data.data.exchange_info_list.sort((a,b) => a - b));
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllDistanceRanges(el, ref) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-year-distance`,
      headers: {
        'x-flow': "BC_CREATE"
      },
      params: {
        model_ref: modelRef || ref,
        year: el
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setRange(resp.data.data.exchange_info_list.sort((a,b) => a.from_distance - b.from_distance));
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  const getExchangeStaticData = async () => {
    const response = await (await fetch("/api/exchange/getExchangeStaticData")).json();
    setColorGroups(response.color_groups)
    setSplitPayErrorHeader(response.bc_split_err_msg?.header)
    setSplitPayErrorSubtext(response.bc_split_err_msg?.subtext)
  }

  function handlePartnerSearch(val) {
    setSearchPartner(val)
    console.log(val, "inside search");
    let temp = JSON.parse(JSON.stringify(exchangePatnerData))
    setFilterPartnerArray(temp?.filter(el => new RegExp(val?.toLowerCase()).test(el?.partner_name?.toLowerCase())))
  }

  function handleBikeExchnage(el) {
    //after selecting exchange patner
    setExchangeSelected(true)
    setExchangePatner(el)
    setShowExchangePatner(false)
  }

  const checkLogicForBtnDisabled = () => {
    if (
      exchangePatner?.id &&
      brandName &&
      modelName &&
      modelYear &&
      bikeLoan &&
      bikeCondtion &&
      ownersName?.trim() &&
      kilometer &&
      bikeCondtion !== "Not working" &&
      bikeLoan !== "Pending" &&
      exchangeValue && 
      registrationNo && 
      ownership &&
      Object.keys(vehConditionList)?.length >= 2 && 
      Object.keys(scooterRegList)?.length >= 1 
      // transactionId.length
      // (orderUserData?.action == "CREATE_NEW" ? Object.keys(vehConditionList)?.length >= 2 : true) && 
      // (orderUserData?.action == "CREATE_NEW" ? Object.keys(scooterRegList)?.length >= 1 : true) &&
    //   (
    //   brandName != previousBikeData.brand ||
    //   modelName != previousBikeData.model ||
    //   bikeLoan != previousBikeData?.other_attributes?.loan_status ||
    //   modelYear != previousBikeData.year ||
    //   bikeCondtion != previousBikeData?.other_attributes?.running_condition ||
    //   ownersName != previousBikeData.owner_name ||
    //   exchangeValue != previousBikeData.exchange_value ||
    //   registrationNo != previousBikeData?.other_attributes?.registration_number ||
    //   ownership != previousBikeData?.other_attributes?.ownership ||
    //   kilometer?.from_distance != previousBikeData?.from_distance || 
    //   kilometer?.to_distance != previousBikeData?.to_distance || 
    //   variantName != previousBikeData.variant  || 
    //   colorName != previousBikeData.color  || 
    //   pincode != previousBikeData.pin_code 
    //   )
      //   exchangeDiscountQotation.quotation_value > 0
    ) {
      setContinueBtnDisabled(false);
    } else {
      setContinueBtnDisabled(true);
    }
  };

  //   const callGetOffers = () => {
  //     if (
  //       !!(
  //         brandName &&
  //         modelName &&
  //         modelYear &&
  //         ownership &&
  //         (kilometer.from_distance || kilometer.to_distance)
  //       )
  //     ) {
  //       getExchangeOfferPrice({
  //         brand: brandName,
  //         model: modelName,
  //         year: modelYear,
  //         from_distance: kilometer.from_distance,
  //         to_distance: kilometer.to_distance,
  //         ownership: ownership,
  //       });
  //     }
  //   };

  //   useEffect(() => {
  //     callGetOffers();
  //   }, [callTime]);

  const handleBrandDropDown = (el) => {
    //after selecting brand
    // setDataOfSelectedBrand(el);
    getAllModels(el)
    setModelName("");
    setModelSelected(false);
    setModelYear("");
    setModelYearSelected(false);
    setBrandName(el);
    setBrandSelected(true);
    setShowBrand(false);
    setVariantName("")
    setColorName("")
    setKilometer({})
    setBikeRangeSelected(false);

    setSearchedBrand("")
  };

  const handleModelDropDown = (el) => {
    //after selecting model
    // setyear(el?.year);
    getAllVariants(el)

    setModelName(el);
    setModelSelected(true);
    setShowModel(false);
    setModelYear("");
    setModelYearSelected(false);
    setVariantName("")
    setColorName("")
    setKilometer({})
    setBikeRangeSelected(false);

    setSearchedModel("")
  };

  const handleModelYearDropDown = (el) => {
    //after selecting year
    // getAllDistanceRanges(el)

    setModelYear(el);
    setModelYearSelected(true);
    setShowModelYear(false);
    setKilometer({})
    setBikeRangeSelected(false);
    // setTimeout(()=>setCallTime(!callTime), 100)
    // if (
    //   brandName &&
    //   modelName &&
    //   ownership &&
    //   (kilometer.from_distance || kilometer.to_distance)
    // ) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: el,
    //     from_distance: kilometer.from_distance,
    //     to_distance: kilometer.to_distance,
    //     ownership: ownership,
    //   });
    // }
  };

  const handleLoanDropDown = (el) => {
    //after selecting loan
    setBikeLoan(el);
    setBikeLoanSelected(true);
    setShowBikeLoan(false);
  };

  const handleConditionDropDown = (el) => {
    //after selecting condition
    setBikeCondtion(el);
    setBikeConditionSelected(true);
    setShowBikeCondition(false);
  };

  const handleRangeDropDown = (el) => {
    setKilometer(el);
    setBikeRangeSelected(true);
    setShowBikeRange(false);
    // setTimeout(()=>setCallTime(!callTime), 100)
    // if (brandName && modelName && modelYear && ownership) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: modelYear,
    //     from_distance: el.from_distance,
    //     to_distance: el.to_distance,
    //     ownership: ownership,
    //   });
    // }
  };
  const onChangeOfModel = () => {
    if (brandName) {
      setShowModel(!showModel);
    } else {
      toggleToaster(`Please select brand first`)
    }
  };

  const oncChangeOfYear = () => {
    if (brandName && modelName && year?.length) {
      setShowModelYear(!showModelYear);
    } else {
      toggleToaster(`Please select model first`)
    }
  };

  const toggleToaster = (msg, time = 2000) => {
      setShowToggle(true)
      setToastMsg(msg)
      setTimeout(() => {
        setShowToggle(false)
        setToastMsg("")
      }, time)
  }

  const onOwnersNameChange = (val) => {
    let reg = /^[a-zA-Z0-9 ]{0,29}$/;
    if (reg.test(val.target.value)) {
      setOwnersName(val.target.value);
    }
  };

  const handleOwnershipDropDown = (el) => {
    //after selecting condition
    setOwnership(el);
    setOwnershipSelected(true);
    setShowOwnership(false);
    // if (brandName && modelName && modelYear && ownership) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: modelYear,
    //     from_distance: kilometer.from_distance,
    //     to_distance: kilometer.to_distance,
    //     ownership: el,
    //   });
    // }
  };

  const showConfirmPopup = () => {
    if (!continueBtnDisabled) {
    setShowVerifyPopup(true)
    }
  };

  const onFileChange = (evt, index) => {
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic)$/i;
    const [file] = evt.target?.files;
    let extension = file?.name.substr(file?.name.lastIndexOf("."));
    let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2); 
    if (allowedExtensions.exec(extension)) {
      if (size <= 7) {
        let mimeType = file?.type;
        let reader = new FileReader();
        let base64Version = '';
        reader.readAsDataURL(file);
        reader.onload = async function () {
          base64Version = reader.result;
          if (base64Version) {
            // vehConditionList[`preview-img-${index}`] = base64Version
            // setVehConditionList({
            //   ...vehConditionList
            // })
            saveEachDocument(`VEHICLE_CONDITION_${index + 1}`, base64Version)
          }
        };
        if (file) {
          if (extension == ".pdf" || extension == ".heic") {
            document.getElementById('preview-img-' + index).src = CheckTick
            document.getElementById('preview-img-' + index).style.width = "20%"
            document.getElementById('preview-img-' + index).style.left = "38%"
          } else {
            document.getElementById('preview-img-' + index).src = URL.createObjectURL(file);
            document.getElementById('preview-img-' + index).style.width = "100%"
            document.getElementById('preview-img-' + index).style.left = "0"
          }
        }
      } else {
        handleToast("please upload images less than 7 mb")
      }
    } else {
      handleToast("please upload images of type(jpeg,jpg,png)")
    }
  };

  const onRegFileChange = (evt, index) => {  
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic)$/i;
    const [file] = evt.target?.files;
    let extension = file?.name.substr(file?.name.lastIndexOf("."));
    let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2); 
    if (allowedExtensions.exec(extension)) {
      if (size <= 7) {
        let mimeType = file?.type;
        let reader = new FileReader();
        let base64Version = '';
        reader.readAsDataURL(file);
        reader.onload = async function () {
          base64Version = reader.result;
          if (base64Version) {
            // scooterRegList[`reg-preview-img-${index}`] = base64Version
            // setScooterRegList({
            //   ...scooterRegList
            // })
            saveEachDocument("SCOOTER_REGISTRATION", base64Version)
          }
        };
        if (file) {
          if (extension == ".pdf" || extension == ".heic") {
            document.getElementById('reg-preview-img-' + index).src = CheckTick
            document.getElementById('reg-preview-img-' + index).style.width = "20%"
            document.getElementById('reg-preview-img-' + index).style.left = "38%"
          } else {
            document.getElementById('reg-preview-img-' + index).src = URL.createObjectURL(file);
            document.getElementById('reg-preview-img-' + index).style.width = "100%"
            document.getElementById('reg-preview-img-' + index).style.left = "0"
          }
        }
      } else {
        handleToast("please upload images less than 7 mb")
      }
    } else {
      handleToast("please upload images of type(jpeg,jpg,png)")
    }
  };

  const saveDetails = () => {
    if (continueBtnDisabled) return;
    let config = {
      method: "put",
      url: `api/exchange/saveExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        ...bikePayload,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
            verifyExchange("VERIFIED")
        }
      })
      .catch((err) => {
        setVerifyPopup(false)

        // toggleToaster(`Somethin went wrong`)
        if(err?.response?.data?.status == "EXCHANGE_VALUE_MORE_THAN_BALANCE_AMOUNT") {
          setShowSplitErrorPopup(true);
        }

        setTimeout(() => {
          err?.response?.data?.status && handleToast(err?.response?.data?.status, 3000)
        }, 100)
        setIsLoading(false)
      });
  }

  const saveEachDocument = (type, file) => {
    let fileBody = {
      file: file,
      type: type,
      view: "FRONT",
      data: {},
      is_address_proof: false,
    }

    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: orderUserData?.order_id,
      files: [fileBody],
    };
    let config = {
      method: "put",
      url: `api/exchange/uploadScooter`,
      params: {
        ...orderUserData,
      },
      data: { ...uploadBody },
    };

    setIsLoading(true)

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data?.status === "SUCCESS") {
          setIsLoading(false)
          // saveDetails()
          if (type === "SCOOTER_REGISTRATION") {
            document.getElementById('reg-preview-img-' + 0).style.border = '2px solid lawngreen';
            scooterRegList[`reg-preview-img-${0}`] = file
            setScooterRegList({
              ...scooterRegList
            })
          } else {
            let index = type.split(`VEHICLE_CONDITION_`)[1]
            document.getElementById('preview-img-' + (index-1)).style.border = '2px solid lawngreen';
            vehConditionList[`preview-img-${index-1}`] = file
            setVehConditionList({
              ...vehConditionList
            })
          }
        }
      })
      .catch((err) => {
        if (type === "SCOOTER_REGISTRATION") {
          document.getElementById('reg-preview-img-' + 0).style.border = '2px solid red'
        } else {
          let index = type.split(`VEHICLE_CONDITION_`)[1]
          document.getElementById('preview-img-' + index).style.border = '2px solid red'
        }
        setIsLoading(false)
      });

  }

  const saveDocuments = () => {
    setIsLoading(true)
   let scooterImages = []
   let regImages = []
   if (vehConditionList) {
     scooterImages = Object.values(vehConditionList)
   }

   if (scooterRegList) {
    regImages = Object.values(scooterRegList)  
   }

    let finalArr = [];
    scooterImages.map((a) =>
      finalArr.push({
        file: a,
        type: "VEHICLE_CONDITION",
        view: "FRONT",
        data: {},
        is_address_proof: false,
      })
    );

    regImages.map((a) =>
      finalArr.push({
      file: a,
      type: "SCOOTER_REGISTRATION",
      view: "FRONT",
      data: {},
      is_address_proof: false,
    })
  );

    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: orderUserData?.order_id,
      files: [...finalArr],
    };
    let config = {
      method: "put",
      url: `api/exchange/uploadScooter`,
      params: {
        ...orderUserData,
      },
      data: { ...uploadBody },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data?.status === "SUCCESS") {
          saveDetails()
        }
      })
      .catch((err) => {
        setIsLoading(false)
      });
  }

  const handleSubmit = () => {
    if (!isLoading) {
      setIsLoading(true)
      if (false && orderUserData?.action == "CREATE_NEW") {
       saveDocuments()
      } else {
        saveDetails()
      }
    }
  }

  const handleToast = (msg, timer) => {
    setToastMessage(msg);
    setShowToast('block');
    setTimeout(() => {
      setShowToast('none');
    }, timer || 2000);
  }


  const onChangeOfVariant = () => {
    if (brandName && modelName) {   
        setShowVariant(!showVariant)
    }
    else {
        toggleToaster(`Please select brand and model first`)
    }
}

const onChangeOfColor = () => {
    if (brandName && modelName && variantName) {   
        setShowColor(!showColor)
    }
    else {
        toggleToaster(`Please select brand, model and variant first`)

    }
}

const handleVariantDropDown = (el) => {
  getAllColors(el)

  setVariantName(el)
  setShowVariant(false)
  setVariantSelected(true)
  setColorName("")
  setColorSelected(false)
  setModelYear("")
  setModelYearSelected(false)
  setKilometer({})
  setBikeRangeSelected(false);

  setSearchedVariant("")
}

const handleColorDropDown = (el) => {
  getAllYears(el)

  setModelRef(el.model_ref)
  setColorName(colorGroups[el.color] ? colorGroups[el.color]?.join("/") : el.color)
  setColorGroupSelected(el.color)
  setShowColor(false)
  setColorSelected(true)
  setModelYear("")
  setModelYearSelected(false)
  setKilometer({})
  setBikeRangeSelected(false);
  // setyear(dataOfSelectedBrand?.models.find(model => model.model == modelName)?.variants.find(v => v.variant == variantName)?.colors.find(col => col.color == el)?.year)
}

const removeExchangeOffer = () => {
    // setLoader(true); 
    let config = {
      method: "delete",
      url: `api/exchange/deleteExchangeDetail`,
      params: {
        ...orderUserData,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
        //   setLoader(false);
        }
        history.push("/search-exchange")
      })
      .catch((err) => {
        // setLoader(false);
      });
  }

  const disableReject = () => {
    if(rejectMessage === "" || rejectMessage === "Others" && otherRemarks === "") {
      return true
    } else {
      return false
    }
  }

  const verifyExchange = (types) => {
    // if(types === "REJECTED" && rejectMessage === "" || types === "REJECTED" && rejectMessage === "Others" && otherRemarks === "") {
    //   return
    // }
    // if (types == "VERIFIED") {
    //   setVerifyPopup(false);
    //   return
    // } else {
    //   setRejectPopup(false);
    // }

    let config = {
      method: "put",
      url: `api/exchange/verifyExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        status: types,
        message: otherRemarks || rejectMessage || "",
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
        setVerifyPopup(false)
        //   setLoader(false);
        // handleToast("Successfully verified")
        setTimeout(() => history.replace("/booking-list"), 3000)
        }
      })
      .catch((err) => {
        console.log("failed");
        // setLoader(false);
      });

  };

  const handleOrderTitle = (action) => {
    if (action == "CREATE_NEW") {
       return "Create exchange offer"
    } else if (action == "VIEW_EDIT") {
       return "Edit exchange offer"
    } else if (action == "VERIFY_EXCHANGE") {
      return "Verify exchange offer"
    }
  }

  const handleRejectBtn = () => {
    if (continueBtnDisabled) return;
    let config = {
      method: "put",
      url: `api/exchange/saveExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        ...bikePayload,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          if(rejectMessage == rejectReasons[0]) {
            verifyExchange("SOFT_REJECTED");
          } else {
            verifyExchange("REJECTED");
          }
        }
      })
      .catch((err) => {
        // toggleToaster(`Somethin went wrong`)
        setTimeout(() => {
          err?.response?.data?.status && handleToast(err?.response?.data?.status, 3000)
        }, 100)
        setIsLoading(false)
      });
  }




  return (
    <>
      <div className="loan-container eb-input-section-main-wrapper">
        <div className="backArrow" style={{ marginLeft: "0" }} onClick={() => {
          history.goBack();
        }}>
          {/* <Link
            to={{
              pathname: `/scooter-exchange-data`,
              state: {
                ...orderUserData,
              },
            }}
          > */}
            <BackArrow removeClass={true} />
          {/* </Link> */}
        </div>
        <div>
          <div style={{ margin: "0" }} className="header-text">
            {handleOrderTitle(orderUserData?.action)}
          </div>
          <div
            style={{ margin: "0", marginBottom: "24px" }}
            className="popup-sub"
          >
            {history.location.state?.order_id}
          </div>
        </div>
        <div className="eb-brand-input-div">
          <div className="eb-brand-selection-div eb-single-inp-div">
            {/* exchange partner */}
            <FloatingSelect
              labelName={"Exchange Partner"}
              inputValue={exchangePatner?.partner_name}
              onChange={() => setShowExchangePatner(!showExchangePatner)}
              isSelected={exchangeSelected}
            />
          </div>
          <div className="eb-brand-selection-div eb-single-inp-div">
            {/* brand  */}
            <FloatingSelect
              labelName={"Brand"}
              inputValue={brandName}
              onChange={() => setShowBrand(!showBrand)}
              isSelected={brandSeleceted}
            />
          </div>
          <div className="eb-model-selection-div eb-single-inp-div">
            {/* model */}
            <FloatingSelect
              labelName={"Model"}
              inputValue={modelName}
              onChange={() => onChangeOfModel()}
              isSelected={modelSeleceted}
            />
          </div>
          <div className='eb-model-selection-div eb-single-inp-div'>
              {/* variant */}
              <FloatingSelect
                labelName={"Variant"}
                inputValue={variantName}
                onChange={() => onChangeOfVariant() }
                isSelected={variantSeleceted}
              />
          </div>
          <div className='eb-model-selection-div eb-single-inp-div'>
            {/* color */}
            <FloatingSelect
              labelName={"Color"}
              inputValue={colorName}
              onChange={() => onChangeOfColor() }
              isSelected={colorSeleceted}
            />
          </div>
          <div className="eb-year-selection-div eb-single-inp-div">
            {/* year */}
            <FloatingSelect
              labelName={"Year of manufacture"}
              inputValue={modelYear}
              onChange={() => oncChangeOfYear()}
              isSelected={modelYearSeleceted}
            />
          </div>
          {/* <div className='eb-single-inp-div'>
            { Pincode of reg }
            <FloatingInput
                id="number"
                onBlur={() => {}}
                onFocus={() => {}}
                name="regNum"
                type="number"
                maxLength="6"
                labelName="PIN code of registration"
                inputValue={pincode}
                onChange={(val) => {setPincode(val)}}
                placeholder="PIN code of registration"
                className={"eb-floatingInput"}
            />
          </div> */}
          <div className="eb-single-inp-div">
            {/* kilometer range */}
            <FloatingSelect
              labelName={"Kilometre range"}
              inputValue={
                (kilometer.from_distance >= 60000 && kilometer.to_distance == 300000) ? `Greater than ${kilometer.from_distance}` : kilometer.from_distance + " - " + kilometer.to_distance
              }
              onChange={() => setShowBikeRange(!showBikeRange)}
              isSelected={bikeRangeSelected}
            />
          </div>
          <div className="eb-loan-selection-div eb-single-inp-div">
            {/* loan */}
            <FloatingSelect
              labelName={"Loan"}
              inputValue={bikeLoan}
              onChange={() => setShowBikeLoan(!showBikeLoan)}
              isSelected={bikeLoanSeleceted}
            />
            {bikeLoan === "Pending" && (
              <p className="notEligible">Not eligible for exchange program</p>
            )}
          </div>
          <div className="eb-condition-selection-div eb-single-inp-div">
            {/* condtion */}
            <FloatingSelect
              labelName={"Vehicle Condition"}
              inputValue={bikeCondtion}
              onChange={() => setShowBikeCondition(!showBikeCondition)}
              isSelected={bikeConditionSeleceted}
            />
            {bikeCondtion === "Not working" && (
              <p className="notEligible">Not eligible for exchange program</p>
            )}
          </div>

          <div className="eb-condition-selection-div eb-single-inp-div">
            {/* Ownership */}
            <FloatingSelect
              labelName={"Ownership"}
              inputValue={ownershipMap[ownership]}
              onChange={() => setShowOwnership(!showOwnership)}
              isSelected={ownershipSeleceted}
            />
          </div>


          <div className="eb-single-inp-div">
            {/* owner name */}
            <FloatingInput
              id="full_name"
              onBlur={() => {}}
              onFocus={() => {}}
              name="ownerName"
              type="text"
              maxLength="30"
              labelName="Owner’s name"
              inputValue={previousBikeData?.owner_name || ownersName}
              onChange={(val) => {
                onOwnersNameChange(val);
              }}
              placeholder="Owner’s name"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            {/* Registratioon Number */}
            <FloatingInput
              id="registrationNo"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Registration Number"
              type="text"
              maxLength="10"
              labelName="Registration Number"
              inputValue={previousBikeData?.other_attributes?.registration_number || registrationNo}
              onChange={(val) => setRegistrationNo(val)}
              placeholder="Registration Number"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            {/* Exchange value */}
            <FloatingInput
              id="currency-IN"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Exchange value"
              type="text"
              labelName="Exchange value"
              inputValue={previousBikeData?.exchange_value || exchangeValue}
              onChange={(val) => {
                setExchangeValue(val)
              }}
              placeholder="Exchange value"
              className={"eb-floatingInput"}
              disabled={orderUserData?.action == "VERIFY_EXCHANGE"}
            />
          </div>
          {/* Input for Transaction Id */}
          {/* cpommented for release uncomment when backend supports */}
          {/* <div className="eb-single-inp-div">
            <FloatingInput
              id="registrationNo"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Transaction ID"
              type="text"
              labelName="Transaction ID"
              inputValue={previousBikeData?.transaction_id || transactionId}
              onChange={(val) => {
                setTransactionId(val)
              }}
              placeholder="Transaction ID"
              className={"eb-floatingInput"}
            />
          </div> */}
          {/* <div className="eb-single-inp-div">
           Bike reg num
          <FloatingInput
            id="username"
            onBlur={() => {
              checkValidOwnerName(regNumber);
            }}
            onFocus={() => {
              checkValidOwnerName(regNumber);
            }}
            name="regNum"
            type="text"
            maxLength="30"
            labelName="Registration Number"
            inputValue={
              previousBikeData?.other_attributes?.owner_name || regNumber
            }
            onChange={(val) => {
              setRegNumber(val.target.value);
            }}
            placeholder="Registration Number"
            className={"eb-floatingInput"}
          />
        </div>*/} 
        {
          true && (
            <div className="uploadWrapper">
            <p className="title">
            Old 2-wheeler pictures
            </p>
            <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p>
            <div className="uploadImgWrapper">
              {
                new Array(scooterRegImgLimit).fill(1)?.map((list, index) => (
                  <div key={index} className="uploadImage">
                    {
                      !scooterRegList?.["reg-preview-img-" + index] && (
                        <img className="plus-icon" src={PlusIcon} alt="" />
                      )
                    }
                      
                      <input
                        className="input-file"
                        id={'uploadInput-1-' + index}
                        type="file"
                        data
                        onChange={(evt) => onRegFileChange(evt, index)}
                      />
                       <div
                        style={{ display: scooterRegList?.["reg-preview-img-" + index] ? 'block' : 'none' }}
                        className="upload-preview-img"
                      >
                        <img className="previewImg" id={"reg-preview-img-" + index} src="#" alt="" />  
                      </div>
                  </div>
                ))
              }
            </div>

            {/* <p className="deleteTitle" onClick={() => setScooterRegList({})}>
              *Remove Scooter Registration Images
            </p>
   */}
            <p className="uploadDocTitle">
              Vehicle Condition* (please upload atleast 2 images)
            </p>
  
            <div className="uploadImgWrapper">
              {
                new Array(vehConditionLimit).fill(1)?.map((list, index) => (
                  <div key={index} className="uploadImage">
                    {
                      !vehConditionList?.["preview-img-" + index] && (
                        <img className="plus-icon" src={PlusIcon} alt="" />
                      )
                    }
                      
                      <input
                        className="input-file"
                        id={'uploadInput-2-' + index}
                        type="file"
                        data
                        onChange={(evt) => onFileChange(evt, index)}
                      />
                       <div
                        style={{ display: vehConditionList?.["preview-img-" + index] ? 'block' : 'none' }}
                        className="upload-preview-img"
                      >
                        <img className="previewImg" id={"preview-img-" + index} src="#" alt="" />  
                      </div>
                  </div>
                ))
              }
            </div>
            {/* <p className="deleteTitle" onClick={() => {
              setVehConditionList({})
            }}>
              *Remove Vehicle Condition Images
            </p> */}
          </div>
          )
        }

        </div>
        {/* <div>
          <button
            onClick={showConfirmPopup}
            className="primary-btn"
            style={{
              cursor: continueBtnDisabled ? "disabled" : "pointer",
              background: continueBtnDisabled ? "rgba(0, 0, 0, 0.36)" : "black",
              width: '100%'
            }}
          >
            Next
          </button>
        </div> */}

            <div className="verify-btn-cont">
          <button className="verify-sec-btn" style={{
            cursor: continueBtnDisabled ? "disabled" : "pointer",
            pointerEvents: continueBtnDisabled ? "none" : "visible",
            opacity: continueBtnDisabled?"0.2":"1",
          }} onClick={() => { 
            !isLoading && setRejectPopup(true)
              }}>
                Reject
              </button>
              <button
              style={{
                cursor: continueBtnDisabled ? "disabled" : "pointer",
                pointerEvents: continueBtnDisabled ? "none" : "visible",
                background: continueBtnDisabled ? "rgba(0, 0, 0, 0.36)" : "black",
                width: '100%'
              }}
                className="primary-btn"
                onClick={() => {
                    !isLoading && setVerifyPopup(true)
                }}
              >
              Verify
              </button>
            </div>

        {showToggle && <div className="toaster">{toastMsg}</div>}

        {/* exchange partner drop down */}
        {showExchangePatner &&
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowExchangePatner(false);
                handlePartnerSearch("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  2-Wheeler Exchange Partner
                </div>
                <div style={{ marginBottom: '20px' }} className="search-by-exchange-partner">
                  <FloatingInput
                    id="exchange_partner"
                    name="exchange_partner"
                    type="text"
                    labelName="search exchange partner"
                    inputValue={searchPartner}
                    onChange={(val) => { handlePartnerSearch(val?.target?.value) }}
                    placeholder="Search Exchange Partner"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                  <>
                    {filterPartnerArray?.map((el, i) => {
                      return <> <div
                        className="eb-individual-brand-drop-down-div eb-common-single-div"
                        key={i}
                        onClick={
                          () => { handleBikeExchnage(el) }
                        }
                      >
                        {el?.partner_name}
                      </div>
                      </>
                    })}
                  </>
                </div>
              </div>
            </GenericModal>
          </div>
        }



        {/* Brand drop down */}
        {showBrand && (
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBrand(false);
                setSearchedBrand("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Brand
                </div>
                <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_brand"
                    name="vehicle_brand"
                    type="text"
                    labelName="search vehicle brand"
                    inputValue={searchedBrand}
                    onChange={(val) => { setSearchedBrand(val?.target?.value) }}
                    placeholder="Search Vehicle Brand"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                {searchedBrand.length == 0 ? brands.map((el, i) => (
                    <div
                      onClick={() => {
                        handleBrandDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  )) : brands.filter((a) => a.toLocaleLowerCase().includes(searchedBrand.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleBrandDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike model drop down */}
        {showModel && (
          <div className="eb-model-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowModel(false);
                setSearchedModel("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-model-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Model
                </div>
                <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_model"
                    name="vehicle_model"
                    type="text"
                    labelName="search vehicle model"
                    inputValue={searchedModel}
                    onChange={(val) => { setSearchedModel(val?.target?.value) }}
                    placeholder="Search Vehicle Model"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="model-options-div eb-drop-down-options exchange-partner-map-div">
                {searchedModel.length == 0 ? models.map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelDropDown(el);
                      }}
                      className="eb-individual-model-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  )) : models.filter((a) => a.toLocaleLowerCase().includes(searchedModel.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelDropDown(el);
                      }}
                      className="eb-individual-model-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike year drop down */}
        {showModelYear && (
          <div className="eb-modelYear-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowModelYear(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-modelYear-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Year of manufacture
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {year.map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelYearDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike Loan drop down */}
        {showBikeLoan && (
          <div className="eb-loan-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeLoan(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-loan-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Loan Status
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {loan.map((el, i) => (
                    <div
                      onClick={() => {
                        handleLoanDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike condition drop down */}
        {showBikeCondition && (
          <div className="eb-condition-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeCondition(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Condition
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {condtion.map((el, i) => (
                    <div
                      onClick={() => {
                        handleConditionDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike Range drop down */}
        {showBikeRange && (
          <div className="eb-condition-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeRange(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Range
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {range.map((el, i) => (
                    <div
                      onClick={() => {
                        handleRangeDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {(el.from_distance >= 60000 && el.to_distance == 300000) ? `Greater than ${el.from_distance}` : el.from_distance + " - " + el.to_distance}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Ownership drop down */}
        {showOwnership && (
          <div className="eb-ownership-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowOwnership(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Ownership
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {ownerships.map((el, i) => (
                    <div
                      onClick={() => {
                        handleOwnershipDropDown(el);
                      }}
                      className="eb-individual-ownership-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {ownershipMap[el]}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* show verify popup */}
        {showVerifyPopup && (
            <GenericModal
              onClose={() => {
                if (!isLoading) {
                  setShowVerifyPopup(false)
                }
              }}
              showClose={false}
            >
            <div className="verifyPopupWrapper">
              <div className="headerContainer">
                <div>
                    <div style={{ margin: "0" }} className="header-text">
                  Confirm exchange offer
                  </div>
                  <div
                    style={{ margin: "0", marginBottom: "24px" }}
                    className="popup-sub"
                  >
                    {history.location.state?.order_id}
                  </div>
                 </div>
                 <img src={exchangeIcon} alt="" />
              </div>

              <div className="container">
                <div className="list">
                  <p className="label">
                  Bike details
                  </p>
                  <p className="value">
                  {brandName} {modelName} ({modelYear}) ({(kilometer.from_distance >= 60000 && kilometer.to_distance == 300000) ? `Greater than ${kilometer.from_distance}` : kilometer.from_distance + " - " + kilometer.to_distance}) KM
                  </p>
                </div>
                <div className="list">
                  <p className="label">
                  Exchange value
                  </p>
                  <p className="value">
                  {exchangeValue}
                  </p>
                </div>
                <div className="btnContainer">
                  <div className="greyBtn" onClick={() => !isLoading && setShowVerifyPopup(false)}>
                  Cancel
                  </div>
                  <div className="blackBtn" onClick={handleSubmit}>
                  Confirm
                  </div>
                </div>
              </div>
              </div>
            </GenericModal>
        )}

        {/* Bike Variant drop down */}
        {showVariant &&
              <div className='eb-model-drop-down  eb-common-drop-down-container'>
                  <GenericModal onClose={() => { setShowVariant(false); setSearchedVariant("") }} showClose={false} botSheet={true}>
                      <div className='eb-inside-generic-model-drop-down eb-common-div'>
                          <div className='eb-bike-title eb-drop-down-title'>Variant</div>
                          <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                          <FloatingInput
                            id="vehicle_variant"
                            name="vehicle_variant"
                            type="text"
                            labelName="search vehicle variant"
                            inputValue={searchedVariant}
                            onChange={(val) => { setSearchedVariant(val?.target?.value) }}
                            placeholder="Search Vehicle Variant"
                            className={"eb-floatingInput"}
                            maxLength="10"
                          />
                          </div>
                          <div className='model-options-div eb-drop-down-options exchange-partner-map-div'>
                          {searchedVariant.length == 0 ? variants?.map((el, i) => (
                                  <div onClick={() => { handleVariantDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                      {el}
                                  </div>
                              )) : variants?.filter((a) => a.toLocaleLowerCase().includes(searchedVariant.toLocaleLowerCase()))?.map((el, i) => (
                                <div onClick={() => { handleVariantDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                    {el}
                                </div>
                            ))}
                          </div>
                      </div>
                  </GenericModal>
              </div>
          }

          {/* Bike Color drop down */}
            {showColor &&
              <div className='eb-model-drop-down  eb-common-drop-down-container'>
                  <GenericModal onClose={() => { setShowColor(false) }} showClose={false} botSheet={true}>
                      <div className='eb-inside-generic-model-drop-down eb-common-div'>
                          <div className='eb-bike-title eb-drop-down-title'>Color</div>
                          <div className='model-options-div eb-drop-down-options'>
                              {colors.map((el, i) => (
                                  <div onClick={() => { handleColorDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                      {colorGroups[el.color] ? colorGroups[el.color]?.join("/") : el.color}
                                  </div>
                              ))}
                          </div>
                      </div>
                  </GenericModal>
              </div>
          }

{verifyPopup && (
        <GenericModal onClose={() => {
            if (!isLoading) {
                setVerifyPopup(false)
            }
        }} showClose={false}>
          <div className="popupHead">
            <div>Are you sure want to verify this exchange?</div>
            <img src={exchangeIcon} alt="exchangeIcon" />
          </div>

          <div className="popup-sub">
            Make sure you have checked all the properties mentioned
          </div>
          <div className="popup-btn">
            <button className="sec-btn" onClick={() => !isLoading && setVerifyPopup(false)}>
              Dismiss
            </button>
            <button
              onClick={() => !isLoading && handleSubmit()}
              className="primary-btn"
            >
              Verify
            </button>
          </div>
        </GenericModal>
      )}
      {rejectPopup && (
        <GenericModal onClose={() => setRejectPopup(false)} showClose={false} fullScreen={true}>
          <div className="backArrow" onClick={() => setRejectPopup(false)}>
              <BackArrow removeClass={true} />
          </div>
          <div style={{margin: '16px'}}>
          <div className="header-text">Please select reason for rejection</div>
          {rejectReasons.map((rej, i) => (
            <div onClick={() => setRejectMessage(rej)}>
              <div className="radioCont">
              <div className="imgCont">{rej === rejectMessage ? <img src={checked} alt="checked"/> : <div className="greyIcon"></div>}</div>
              <div>{rej}</div>
              </div>
              {rejectMessage === "Others" && rej === "Others" && <textarea className="otherText" value={otherRemarks} onChange={(e) => setOtherRemarks(e.target.value)}></textarea>}
            </div>
          ))}
          <div>
            <button
              onClick={() => handleRejectBtn()}
              className="primary-btn"
              style={{cursor: disableReject() ? "no-drop" : "pointer", background: disableReject() ? "rgba(0, 0, 0, 0.36)" : "black", width: '100%' }}
            >
              Reject
            </button>
          </div>
          </div>
        </GenericModal>
      )}
      {showSplitErrorPopup && (
        <GenericModal onClose={() => setShowSplitErrorPopup(false)} showClose={false}>
          <div className="popupHead">
            <div>{splitPayErrorHeader}</div>
            <img src={exchangeIcon} alt="exchangeIcon" />
          </div>
          <div className="popup-sub">{splitPayErrorSubtext}</div>
          <div>
            <button
              onClick={() => setShowSplitErrorPopup(false)}
              className="primary-btn"
              style={{width: 'calc(100% - 16px)', margin: '8px', marginTop: '16px'}}
            >
              Got It
            </button>
          </div>
        </GenericModal>
      )}

        <div className="toastWrapper">
          <div style={{ display: showToast }} className="toastContainer">
            {toastMessage}
          </div>
        </div>

        {
          isLoading && (
            <Loader/>
          )
        }
      </div>
    </>
  );
}

export default ScooterExchangeVerify;
